import { FC } from 'react';

type SvgProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

const DocumentUploadIllustrationSVG: FC<SvgProps> = ({ className, width = 64, height = 64 }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      {/* Paper Outline with folded corner */}
      <path
        d="M34 8H18C15.7909 8 14 9.79086 14 12V50C14 52.2091 15.7909 54 18 54H34"
        stroke="#ADABAA"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M34 8L48 22V32"
        stroke="#ADABAA"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 8V20C34 21.1046 34.8954 22 36 22H48"
        stroke="#ADABAA"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Horizontal Document Text Lines */}
      <path d="M21 24H28" stroke="#ADABAA" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M21 32H34" stroke="#ADABAA" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M21 40H28" stroke="#ADABAA" strokeWidth="2.5" strokeLinecap="round" />

      {/* Upload Badge (Circle + Arrow) */}
      <circle cx="44" cy="44" r="14" fill="#E2EEDD" />
      <path
        d="M44 51V37M44 37L39 42M44 37L49 42"
        stroke="#0F9B00"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocumentUploadIllustrationSVG;
